<template>
  <div>
    <generic-container
      :title="$t('modul manager')"
      icon="settings"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      @add="add"
    >
      <div class="ui three link cards">
        <div
          class="card"
          v-for="(instance, index) in modul_instances"
          :key="index"
          @click="configure(instance)"
        >
          <div class="content">
            <img class="right floated mini ui image" src="/images/icons/module_1.png" />
            <div class="header">{{instance.name}}</div>
            <div class="meta">
              <small>{{instance.create_date | formatDate}}</small>
            </div>
            <div class="description">test</div>
          </div>
          <div class="ui bottom attached basic buttons">
            <div class="ui button" v-on:click.stop="edit(instance, index)">
              <i class="edit icon"></i>
              {{ $t("edit")}}
            </div>
            <div class="ui button" v-on:click.stop="test(instance)">
              <i class="vial icon"></i>
              {{ $t("test")}}
            </div>
            <div class="ui button" v-on:click.stop="remove(instance, index)">
              <i class="red trash icon"></i>
              {{ $t("delete")}}
            </div>
          </div>
        </div>
      </div>
    </generic-container>
    <template v-for="(mdl, index) in instance_modals">
      <component
        :is="mdl"
        :key="index"
        :instance="selected_instance"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
    <template v-for="(mdl, index) in configure_modals">
      <component
        :is="mdl"
        :key="index"
        :instance="selected_instance"
        v-on:succedded="destroy"
        v-on:destroy="destroy"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./ModulManagerConfigureModal";
import ModulManagerModal from "./ModulManagerInstanceModal";
import ConfigureInstanceModal from "./ModulManagerConfigureInstanceModal";

export default {
  name: "ModulManager",
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {
      modul_instances: [],
      selected_instance: undefined,
      configure_modal: ConfigureModal,
      instance_modals: [],
      configure_modals: []
    };
  },
  methods: {
    add() {
      this.instance_modals.push(ModulManagerModal);
    },
    succedded(instance) {
      let trgtIdx = this.modul_instances.findIndex(
        n => n.instance_id == instance.instance_id
      );
      if (trgtIdx == -1) {
        this.modul_instances.push(instance);
      } else {
        this.modul_instances.splice(trgtIdx, 1, instance);
      }
      this.destroy();
    },
    destroy() {
      this.instance_modals = [];
      this.configure_modals = [];
      this.selected_instance = undefined;
    },
    edit(instance) {
      this.selected_instance = instance;
      this.instance_modals.push(ModulManagerModal);
    },
    test(instance) {
      let vm = this;
      local_api(vm, "post", "/modul_manager/do-test", {
        u: instance.uuid
      })
        .then(() => {
          vm.$alertify.success(vm.$t("instance tested ok"));
        })
        .catch(err => {
          vm.$alertify.error(stringify(err));
        });
    },
    remove(instance, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove modul instance?"),
        function() {
          local_api(vm, "post", "/modul_manager/do-remove", {
            u: instance.uuid
          })
            .then(() => {
              vm.modul_instances.splice(index, 1);
            })
            .catch(err => {
              vm.$alertify.error(stringify(err));
            });
        }
      );
    },
    configure(instance) {
      this.selected_instance = instance;
      this.configure_modals.push(ConfigureInstanceModal);
    }
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/modul_manager/do-get-instances")
      .then(instances => {
        this.modul_instances = instances;
      })
      .catch(err => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {}
};
</script>
